export {
  CommunityContextProvider,
  DEFAULT_COMMUNITY,
  DEFAULT_EU_COMMUNITY,
  getDefaultCommunity,
  useCommunityContext,
  type UseCommunityContextOptions,
} from '@highlight-cp/hooks';
export { DeploymentContextProvider, useIsEuHighlighterHost } from './deployment-context';
export {
  OnboardingMachineContext,
  OnboardingMachineProvider,
} from './onboarding-machine-context/onboarding-machine-context';
